import { MantineTheme, Sx } from '@mantine/core';

export const organizationStyles = (theme: MantineTheme): Sx => {
  return {
    '.organisation-tabs': {
      marginBottom: theme.spacing.xl,
    },
  };
};
